import { render, staticRenderFns } from "./RecoveryMailForm.vue?vue&type=template&id=5d446c4c&scoped=true&"
import script from "./RecoveryMailForm.vue?vue&type=script&lang=js&"
export * from "./RecoveryMailForm.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryMailForm.vue?vue&type=style&index=0&id=5d446c4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d446c4c",
  null
  
)

export default component.exports